<template>
    <transition
            :name="slideTransitionName"
            mode="out-in"
            @beforeLeave="slideBeforeLeave"
            @enter="slideOnEnter"
            @afterEnter="slideAfterEnter"
    >
        <slot></slot>
    </transition>
</template>

<script>
    const SLIDE_TRANSITION_NAME = 'slide';

    export default {
        name:    "RouterViewSlideTransition",
        data:    function () {
            return {
                slidePreviousHeight: 0,
                slideTransitionName: SLIDE_TRANSITION_NAME
            }
        },
        created: function () {
            // On route change, decide which animation to use
            this.$router.beforeEach((to, from, next) => {
                this.slideTransitionName = SLIDE_TRANSITION_NAME
                this.slideTransitionName += from.meta.step < to.meta.step ? '-left' : '-right'
                next();
            })
        },
        methods: {
            /**
             * Get the height of the component to be removed
             *
             * @param target
             */
            slideBeforeLeave: function (target) {
                this.slidePreviousHeight = getComputedStyle(target).height
            },

            /**
             * Assign the height of the previous component to the new component at first
             *
             * @param target
             */
            slideOnEnter: function (target) {
                const {height} = getComputedStyle(target)
                this.scrollToTop()
                target.style.height = this.slidePreviousHeight
                setTimeout(() => target.style.height = height)
            },

            /**
             * Height back to auto for the new component
             *
             * @param target
             */
            slideAfterEnter: function (target) {
                target.style.height = 'auto'
            },

            scrollToTop: function () {
                const c = document.documentElement.scrollTop || document.body.scrollTop;
                if (c > 0) {
                    window.requestAnimationFrame(this.scrollToTop);
                    window.scrollTo(0, c - c / 8);
                }
            }
        }
    }
</script>
